export default __webpack_public_path__ + "static/media/f_horizantalrule.62790e44.svg";